import React from "react";
import { connect } from "react-redux";
import NavBar from "devextreme-react/ui/nav-bar";
import { Popup, Button, TextArea, ValidationGroup } from "devextreme-react";
import LoadingOverlay from "../../../../../Shared/LoadingOverlay";
import Prestaciones from "./Prestaciones";
import Trabajadores from "./Trabajadores";
import InformacionGeneral from "./InformacionGeneral";
import { changeTabIndexGestionar, clickBtnGestionar, openCloseModalGestionar, setDataSelected, updateDataGestionar, openCloseModalRejectGestionar, updateSolicitudSel } from "../actions";
import EditBaterias from "./EditBaterias";
import AgregarTrabajadores from "./AgregarTrabajadores";
import validaciones from "../../../../../../helpers/validaciones";
import { openCloseToast } from "../../../../../Global/actions";

const RenderBody = (props) => {
  switch (props.modalGestionar.tabPosition) {
    case 0: {
      return <InformacionGeneral />;
    }
    case 1: {
      if (props.modalGestionar.subTabContent) {
        return <EditBaterias />;
      }
      return <Prestaciones />;
    }
    case 2: {
      if (props.modalGestionar.subTabContent) {
        return <AgregarTrabajadores />;
      }
      return <Trabajadores />;
    }
    default:
      return <div />;
  }
};

class ModalGestionar extends React.PureComponent {
  constructor(props) {
    super(props);
    this.checkItem = this.checkItem.bind(this);
    this.onClickButtonSubTab = this.onClickButtonSubTab.bind(this);
    this.state = {
      textArea: "",
    };
  }

  handleClose = () => {
    this.props.onClose();
  };

  checkItem(e) {
    if (e.itemIndex !== this.props.tabPosition) {
      if (this.props.preventNavigation) {
        this.setState({
          openModal: true,
          redirect: { contentId: e.itemData.contentId, itemIndex: e.itemIndex },
          typeRedirect: "tabs",
        });
      } else {
        this.props.OnchangeTabIndexGestionar(e.itemData.contentId, e.itemIndex);
      }
    }
  }

  onClickButtonSubTab = (subTabContent) => {
    if (subTabContent) {
      this.props.OnClickButtonSubTab(subTabContent);
    } else {
      this.props.dispatch(updateSolicitudSel(this.props.dataSelected));
      this.props.OnClickButtonSubTab(subTabContent);
    }
  }

  handleModalClose = () => {
    this.props.OnClickButtonSubTab(false);
    this.props.dispatch(openCloseModalGestionar(false));
    this.props.dispatch(setDataSelected({}));
  }

  sendSolicitud = () => {
    const _data = {
      RequestId: this.props.dataSelected && this.props.dataSelected.Id ? this.props.dataSelected.Id : 0,
      RequestStatus: 2,
    };
    this.props.dispatch(updateDataGestionar(_data));
  }

  rejectSolicitud = () => {
    const _data = {
      RequestId: this.props.dataSelected && this.props.dataSelected.Id ? this.props.dataSelected.Id : 0,
      RequestStatus: 3,
      Comment: this.state.textArea,
    };
    this.props.dispatch(updateDataGestionar(_data));
  }

  handleModalOpenRejectGestionar = () => {
    this.props.dispatch(openCloseModalGestionar(false));
    this.setState({ textArea: "" });
    this.props.dispatch(openCloseModalRejectGestionar(true));
  }

  handleModalCloseRejectGestionar = () => {
    this.props.dispatch(openCloseModalGestionar(true));
    this.props.dispatch(openCloseModalRejectGestionar(false));
  }

  handleDeleteSelectedWorkers = (params) => {
    const { dataSelected, selectedWorkers } = this.props;
    const newWorkers = [];
    dataSelected.Workers.forEach((w, i) => {
      if (w.Index != null) {
        if (selectedWorkers.findIndex((s) => s.Index === w.Index) === -1) newWorkers.push(w);
      } else if (selectedWorkers.findIndex((s) => s.Id === w.Id) === -1) {
        newWorkers.push(w);
      }
    });
    this.props.dispatch(updateSolicitudSel({
      ...dataSelected,
      Workers: newWorkers,
      newWorkers: [],
      isWorkersUpdate: true,
    }));
  }

  render() {
    const {
      dataSelected, tabPosition, subTabContent, selectedWorkers,
    } = this.props;

    return (
      <div>
        <Popup
          visible={this.props.openModalRejectGestionarSolicitud}
          showTitle
          title="Gestionar solicitud"
          onHiding={this.handleModalCloseRejectGestionar}
          maxWidth={500}
          maxHeight={300}
          dragEnabled={false}
          style={{ borderBottom: 0 }}
          className="modalGestionarSolicitud"
        >
          <div>
            <div className="row">
              <div className="col-12">
                <h3><p className="text-left">Razón del rechazo de la solicitud</p></h3>
                <TextArea
                  height={120}
                  maxLength={200}
                  value={this.state.textArea}
                  valueChangeEvent="keyup"
                  onValueChanged={(v) => this.setState({ textArea: v.value })}
                />
              </div>
            </div>
            <div className="row bottom-button">
              <div className="col-6">
                <Button
                  onClick={this.handleModalCloseRejectGestionar}
                  type="danger"
                  text="Cancelar"
                  disabled={this.props.isLoading}
                />
              </div>
              <div className="col-6">
                <Button
                  onClick={this.rejectSolicitud}
                  type="success"
                  text="Enviar"
                  disabled={!this.state.textArea.trim().length || this.props.isLoading}
                />
              </div>
            </div>
          </div>
        </Popup>
        <Popup
          visible={this.props.openModalGestionarSolicitud}
          showTitle
          showCloseButton
          // fullScreen
          title="Gestionar solicitud"
          onHiding={this.handleModalClose}
          height={600}
          width={800}
          // maxHeight={600}
          dragEnabled={false}
          style={{ borderBottom: 0 }}
          className="modalGestionarSolicitud"
        >
          <div>
            {this.props.isLoading && <LoadingOverlay />}
            <ValidationGroup>
              <div className="row">
                <div className="col-9 tab-seccion">
                  <NavBar
                    disabled={!!subTabContent}
                    dataSource={["Información general", "Baterías/Prestaciones", "Trabajadores"]}
                    selectionMode="single"
                    onItemClick={this.checkItem}
                    className="header-tabs edit-roles-tabs"
                    noDataText="Sin acceso"
                    selectedIndex={tabPosition}
                  />

                </div>
                <div className="col-3">
                  {tabPosition === 1 &&
                    <Button
                      type="success"
                      text={subTabContent ? "Finalizar edición" : "Editar prestaciones"}
                      onClick={() => subTabContent ? this.onClickButtonSubTab(false) : this.onClickButtonSubTab(true)}
                      style={{
                        height: 37,
                        paddingTop: 0,
                        width: 137,
                      }}
                      render={(btn) => (
                        <div
                          style={{
                            padding: "12px 0px 0px 0px",
                            textAlign: "center",
                            display: "flex",
                            justifyContent: "center",
                            height: 97,
                          }}
                        >{btn.text}
                        </div>
                      )}
                    />}

                  {tabPosition === 2 &&
                    <Button
                      type={selectedWorkers && selectedWorkers.length ? "danger" : "success"}
                      text={selectedWorkers && selectedWorkers.length ? "Eliminar" : subTabContent ? "Finalizar edición" : "Agregar trabajador"}
                      useSubmitBehavior={subTabContent}
                      onClick={(params) => {
                        if (subTabContent) {
                          if (dataSelected.newWorkers && dataSelected.newWorkers.length === 0) {
                            this.props.OnClickButtonSubTab(false);
                          } else {
                            const isInvalidRut = this.props.dataSelected.newWorkers.find(e => e.DocumentType === 1 && e.DocumentNumber && !validaciones.validateRut(e.DocumentNumber))
                            const isInvalidMail = this.props.dataSelected.newWorkers.find(e => e.Mail && !validaciones.validarEmail(e.Mail));
                            const isDuplicated = validaciones.checkDuplicatedDocumentNumber(this.props.dataSelected.newWorkers);
                            if (isDuplicated) {
                              this.props.dispatch(openCloseToast({
                                isToastOpen: true,
                                msgToast: "No puede ingresar un número de documento duplicado.",
                                typeStyle: "error",
                                displayTime: 5000,
                              }));
                              return;
                            }else if(isInvalidRut){
                              this.props.dispatch(openCloseToast({
                                isToastOpen: true,
                                msgToast: "Existen RUT incorrectos",
                                typeStyle: "error",
                                displayTime: 5000,
                              }));
                              return;
                            }else if(isInvalidMail){
                              this.props.dispatch(openCloseToast({
                                isToastOpen: true,
                                msgToast: "Existen email incorrectos",
                                typeStyle: "error",
                                displayTime: 5000,
                              }));
                              return;
                            }
                            this.onClickButtonSubTab(false);
                          }
                        } else if (selectedWorkers && selectedWorkers.length) {
                          this.handleDeleteSelectedWorkers();
                        } else {
                          this.onClickButtonSubTab(true);
                        }
                      }}
                      style={{
                        height: 37,
                        paddingTop: 0,
                        width: 137,
                      }}
                      render={(btn) => (
                        <div
                          style={{
                            padding: "12px 0px 0px 0px",
                            textAlign: "center",
                            display: "flex",
                            justifyContent: "center",
                            height: 17,
                          }}
                        >{btn.text}
                        </div>
                      )}
                    />}
                </div>
              </div>
              <RenderBody state={this.state} modalGestionar={this.props} />
            </ValidationGroup>
            <div className="button-row">
              <div>
                <Button
                  onClick={this.handleModalOpenRejectGestionar}
                  type="danger"
                  text="Rechazar"
                  disabled={subTabContent || (selectedWorkers && selectedWorkers.length) ? true : false}
                />
              </div>
              <div>
                <Button
                  onClick={this.sendSolicitud}
                  type="success"
                  text="Aprobar"
                  disabled={subTabContent || (selectedWorkers && selectedWorkers.length) ? true : false}
                />
              </div>
            </div>
          </div>
        </Popup>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.inboxSolicitudes.isLoading,
  tabPosition: state.confirmacionSolicitudesAgendaSel.modalGestionar.tabPosition,
  subTabContent: state.confirmacionSolicitudesAgendaSel.modalGestionar.subTabContent,
  contentId: state.confirmacionSolicitudesAgendaSel.modalGestionar.contentId,
  tabs: state.confirmacionSolicitudesAgendaSel.modalGestionar.tabs,
  preventNavigation: state.global.preventNavigation,
  openModalGestionarSolicitud: state.confirmacionSolicitudesAgendaSel.openModalGestionarSolicitud,
  openModalRejectGestionarSolicitud: state.confirmacionSolicitudesAgendaSel.openModalRejectGestionarSolicitud,
  dataSelected: state.confirmacionSolicitudesAgendaSel.dataSelected,
  selectedWorkers: state.confirmacionSolicitudesAgendaSel.selectedWorkers,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => {
    dispatch(action);
  },

  OnchangeTabIndexGestionar: (contentId, itemIndex) => dispatch(changeTabIndexGestionar(contentId, itemIndex)),
  OnClickButtonSubTab: (subTabContent) => dispatch(clickBtnGestionar(subTabContent)),

});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalGestionar);
